import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bamboo-agent2-home/xml-data/build-dir/DIGIPOST-VNLOGI4-SEAGAME2021WEBDOCKER/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/bamboo-agent2-home/xml-data/build-dir/DIGIPOST-VNLOGI4-SEAGAME2021WEBDOCKER/src/components/home/Slider.tsx");
